var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPositive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#6CCF6A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.795 14.29L8.71 12.205 8 12.91l2.795 2.795 6-6L16.09 9l-5.295 5.29z",
    fill: "#fff",
    stroke: "#fff"
  })));
}

export default SvgPositive;